import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

export interface AppConfig
{
  urlChatMailWS?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private config: AppConfig = null;

  constructor(private http: HttpClient)
  {
  }

  public load(): Promise<any>
  {
    this.config = null;

    return this.http.get('./assets/data/appConfig.json').pipe(
      tap(data => {
        console.log('Found app config file - ./assets/data/appConfig.json');
        console.log(JSON.stringify(data, null, 2));
        this.config = data;
      }),
      catchError(err =>
        {
          console.log('No app config file found - ./assets/data/appConfig.json');
          return EMPTY;
        })
    ).toPromise();
  }

  getConfig(): AppConfig
  {
    return this.config;
  }
}
